import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Fade
} from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import axios from '../../services/axios';
import { Link } from 'react-router-dom';
import ParticlesComponent from './Particles';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await axios.post('/forgot-password', { email });
      setSuccess(res.data.message);
    } catch (err) {
      setError(
        err.response?.data?.message || 'Error al enviar el correo'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fade in timeout={800}>
      <Box sx={styles.container}>
        
        {/* Imagen */}
        <Box sx={styles.imageContainer}></Box>

        {/* Partículas */}
        <ParticlesComponent id="tsparticles" style={styles.particles} />

        {/* Formulario */}
        <Box sx={styles.formContainer}>
          <Box sx={styles.form}>

            <MailOutlineIcon sx={styles.icon} />

            <Typography variant="h4" sx={styles.title}>
              Recuperar contraseña
            </Typography>

            <Typography sx={styles.subtitle}>
              Ingresa tu correo y te enviaremos un enlace
            </Typography>

            <TextField
              label="Correo electrónico"
              fullWidth
              margin="normal"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />

            {success && (
              <Alert severity="success" sx={{ mt: 1 }}>
                {success}
              </Alert>
            )}

            {error && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {error}
              </Alert>
            )}

            <Button
              variant="contained"
              fullWidth
              sx={styles.button}
              onClick={handleSubmit}
              disabled={loading || !email}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: '#fff' }} />
              ) : (
                'Enviar enlace'
              )}
            </Button>

            <Typography sx={styles.linkText}>
              <Link to="/login" style={styles.link}>
                ← Volver al login
              </Link>
            </Typography>

          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
  },

  imageContainer: {
    flex: 0.5,
    display: { xs: 'none', md: 'block' },
    backgroundImage: 'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbJYJun3zdQESqfgIUZQZEsBnpI5AChIfOKQ&s)',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    zIndex: 1200,
  },

  formContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    px: 2,
  },

  form: {
    width: '100%',
    maxWidth: 420,
    padding: { xs: '2rem 1.5rem', md: '2.5rem' },
    borderRadius: '16px',
    backdropFilter: 'blur(15px)',
    background: 'rgba(255,255,255,0.9)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
    textAlign: 'center',
    zIndex: 1,
  },

  icon: {
    fontSize: 45,
    color: '#2a3b87',
    marginBottom: '10px',
  },

  title: {
    fontWeight: 'bold',
    mb: 1,
  },

  subtitle: {
    color: '#666',
    mb: 2,
    fontSize: { xs: '14px', md: '16px' },
  },

  button: {
    mt: 2,
    py: 1.2,
    fontWeight: 'bold',
    textTransform: 'none',
    background: 'linear-gradient(135deg, #2a3b87, #4e73df)',
    borderRadius: '10px',
    transition: '0.3s',
    '&:hover': {
      background: 'linear-gradient(135deg, #1e2a66, #3b5bcc)',
      transform: 'scale(1.02)',
    },
  },

  linkText: {
    mt: 2,
  },

  link: {
    textDecoration: 'none',
    color: '#2a3b87',
    fontWeight: 500,
  },

  particles: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
};

export default ForgotPassword;